import { render, staticRenderFns } from "./IconClearFilter.vue?vue&type=template&id=05790d18"
import script from "./IconClearFilter.vue?vue&type=script&lang=js"
export * from "./IconClearFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports